import { createEntityContext } from "./createEntityContext";

export const {
  EntityContext: PartnerContext,
  EntityProvider: PartnerProvider,
} = createEntityContext("partners", "/api/partners", "_id");
